export const mobileMaxWidth = 500;
export const tabletMaxWidth = 1000;